/* eslint-disable prefer-arrow/prefer-arrow-functions */
import React, { useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

function B2BSignupForm() {
  const [formData, setFormData] = useState({
    companyName: '',
    siret: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    street: '',
    postalCode: '',
    city: '',
    acceptPolicy: false,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { id, type, value, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [id]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!formData.civility) {
      newErrors.civility = 'La civilité est obligatoire.';
    }

    const firstName = formData.firstName.trim();
    if (!firstName) {
      newErrors.firstName = 'Le prénom est obligatoire.';
    } else if (firstName.length < 2) {
      newErrors.firstName = 'Le prénom semble invalide.';
    }

    // ✅ Nom
    const lastName = formData.lastName.trim();
    if (!lastName) {
      newErrors.lastName = 'Le nom est obligatoire.';
    } else if (lastName.length < 2) {
      newErrors.lastName = 'Le nom semble invalide.';
    }

    // ✅ Téléphone
    const phone = formData.phone.trim();
    const phoneRegex = /^(\+?\d{1,3}[\s.-]?)?0?\d([\s.-]?\d{2}){4}$/;

    if (!phone) {
      newErrors.phone = 'Le numéro de téléphone est obligatoire.';
    } else if (!phoneRegex.test(phone)) {
      newErrors.phone = 'Format de téléphone invalide. Exemple : +33 1 23 45 67 89';
    }

    // ✅ Adresse postale
    const street = formData.street.trim();
    if (!street) {
      newErrors.street = "L'adresse postale est obligatoire.";
    } else if (street.length < 5) {
      newErrors.street = "L'adresse postale semble trop courte.";
    }

    // ✅ Code postal (France: 5 chiffres) — si tu veux international, dis-moi
    const postalCode = formData.postalCode.trim();
    const cpRegex = /^\d{5}$/;
    if (!postalCode) {
      newErrors.postalCode = 'Le code postal est obligatoire.';
    } else if (!cpRegex.test(postalCode)) {
      newErrors.postalCode = 'Code postal invalide (ex: 75001).';
    }

    // ✅ Ville
    const city = formData.city.trim();
    if (!city) {
      newErrors.city = 'La ville est obligatoire.';
    } else if (city.length < 2) {
      newErrors.city = 'La ville semble invalide.';
    }

    // ✅ Politique
    if (!formData.acceptPolicy) {
      newErrors.acceptPolicy = 'Vous devez accepter la politique de confidentialité.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});

    try {
      const payload = {
        ...formData,
        // Optionnel: si ton backend attend encore "adresse"
        // adresse: `${formData.adressePostale}, ${formData.codePostal} ${formData.ville}`,
      };

      const res = await axios.post(`/api/b2b/signup`, payload);
      alert(res.data.message || 'Demande enregistrée !');
      history.replace('https://keplertravel.com/');
    } catch (err) {
      const apiMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Erreur d'envoi. Veuillez réessayer.";

      alert(apiMessage);
    }
  };

  const Required = () => <span className="text-danger"> *</span>;

  return (
    <form onSubmit={handleSubmit} className="container mt-4">
      <img
        src="/assets/svg/logos/logo.svg"
        alt="KeplerLogo"
        width="45%"
        style={{ display: 'flex', margin: '0px auto' }}
      />

      <h2 className="text-secondary" style={{ fontSize: '28px', paddingTop: '50px' }}>
        Créer un compte professionnel
      </h2>

      <p style={{ fontSize: '16px' }}>
        Accédez à notre plateforme dédiée aux professionnels pour consulter le catalogue,
        <br />
        vérifier tarifs & disponibilités, effectuer vos réservations et télécharger vos
        <br />
        documents de voyage en toute simplicité.
        <br />
      </p>

      <div className="mb-3">
        <label htmlFor="companyName" className="form-label">
          Nom de l'entreprise
          <Required />
        </label>
        <input
          type="text"
          className="form-control"
          id="companyName"
          value={formData.companyName}
          onChange={handleChange}
          required
          placeholder="Ex : Agence Voyages Soleil"
        />
      </div>

      <div className="row">
        <div className="col-md-2 mb-3">
          <label htmlFor="civility" className="form-label">
            Civilité
            <Required />
          </label>
          <select
            className={`form-control ${errors.civility ? 'is-invalid' : ''}`}
            id="civility"
            value={formData.civility}
            onChange={handleChange}
            required
          >
            {/* <option value="">Sélectionner</option> */}
            <option value="mr">M.</option>
            <option value="mrs">Mme</option>
            <option value="miss">Mlle</option>
          </select>
          {errors.civility && <div className="invalid-feedback">{errors.civility}</div>}
        </div>
        <div className="col-md-5 mb-3">
          <label htmlFor="firstName" className="form-label">
            Prénom
            <Required />
          </label>
          <input
            type="text"
            className={`form-control ${errors.firstName ? 'is-invalid' : ''}`}
            id="firstName"
            value={formData.firstName}
            onChange={handleChange}
            placeholder="Ex : Jean"
            required
          />
          {errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
        </div>

        <div className="col-md-5 mb-3">
          <label htmlFor="lastName" className="form-label">
            Nom
            <Required />
          </label>
          <input
            type="text"
            className={`form-control ${errors.lastName ? 'is-invalid' : ''}`}
            id="lastName"
            value={formData.lastName}
            onChange={handleChange}
            placeholder="Ex : Dupont"
            required
          />
          {errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
        </div>
      </div>
      <div className="mb-3">
        <label htmlFor="siret" className="form-label">
          Numéro SIRET
          <Required />
        </label>
        <input
          type="text"
          className="form-control"
          id="siret"
          value={formData.siret}
          onChange={handleChange}
          required
          placeholder="Ex : 123 456 789 00012"
        />
      </div>
      <div className="mb-3">
        <label htmlFor="email" className="form-label">
          Email professionnel
          <Required />
        </label>
        <input
          type="email"
          className="form-control"
          id="email"
          value={formData.email}
          onChange={handleChange}
          required
          placeholder="Ex : contact@agencevoyage.fr"
        />
      </div>

      <div className="mb-3">
        <label htmlFor="phone" className="form-label">
          Téléphone
          <Required />
        </label>
        <input
          type="tel"
          className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
          id="phone"
          value={formData.phone}
          onChange={handleChange}
          placeholder="Ex : +33 1 23 45 67 89"
          required
        />
        {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
      </div>

      {/* ✅ Nouvelle adresse en 3 champs */}
      <div className="mb-3">
        <label htmlFor="street" className="form-label">
          Adresse postale
          <Required />
        </label>
        <input
          type="text"
          className={`form-control ${errors.street ? 'is-invalid' : ''}`}
          id="street"
          value={formData.street}
          onChange={handleChange}
          placeholder="Ex : 12 Rue des Lilas"
          required
        />
        {errors.street && <div className="invalid-feedback">{errors.street}</div>}
      </div>

      <div className="row">
        <div className="col-md-4 mb-3">
          <label htmlFor="postalCode" className="form-label">
            Code postal
            <Required />
          </label>
          <input
            type="text"
            className={`form-control ${errors.postalCode ? 'is-invalid' : ''}`}
            id="postalCode"
            value={formData.postalCode}
            onChange={handleChange}
            placeholder="Ex : 75000"
            required
          />
          {errors.postalCode && <div className="invalid-feedback">{errors.postalCode}</div>}
        </div>

        <div className="col-md-8 mb-3">
          <label htmlFor="city" className="form-label">
            Ville
            <Required />
          </label>
          <input
            type="text"
            className={`form-control ${errors.city ? 'is-invalid' : ''}`}
            id="city"
            value={formData.city}
            onChange={handleChange}
            placeholder="Ex : Paris"
            required
          />
          {errors.city && <div className="invalid-feedback">{errors.city}</div>}
        </div>
      </div>

      <div className="form-check mb-3">
        <input
          className={`form-check-input ${errors.acceptPolicy ? 'is-invalid' : ''}`}
          type="checkbox"
          id="acceptPolicy"
          checked={formData.acceptPolicy}
          onChange={handleChange}
        />
        <label className="form-check-label" htmlFor="acceptPolicy">
          En créant mon compte, je reconnais avoir pris connaissance et accepter l’ensemble des{' '}
          <a href="/conditions-generales-de-vente" target="_blank" rel="noopener noreferrer">
            Conditions Générales
          </a>{' '}
          ainsi que la{' '}
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
            Politique de confidentialité
          </a>{' '}
          de Kepler Travel
          <span className="text-danger"> *</span>
        </label>
        {errors.acceptPolicy && (
          <div className="invalid-feedback d-block">{errors.acceptPolicy}</div>
        )}
      </div>

      <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
        Créer le compte
      </button>
    </form>
  );
}

export default B2BSignupForm;
